import { createCustomAction } from 'typesafe-actions';

export const showModerationMessage = createCustomAction(
    '@messages/SHOW_MODERATION_MESSAGE',
    type => (campaignId: string): { type: '@messages/SHOW_MODERATION_MESSAGE'; campaignId: string } => ({
        type,
        campaignId
    })
);

export const confirmModerationMessage = createCustomAction('@messages/CONFIRM_MODERATION_MESSAGE');

export const cancelModerationMessage = createCustomAction('@messages/CANCEL_MODERATION_MESSAGE');

export type MessagesAction =
    | ReturnType<typeof showModerationMessage>
    | ReturnType<typeof confirmModerationMessage>
    | ReturnType<typeof cancelModerationMessage>;
